export const UPDATE_DISTRIBUTION_FORM_REDIRECTION =
  'UPDATE_DISTRIBUTION_FORM_REDIRECTION';
